import { render, staticRenderFns } from "./psychologicalCounseling.vue?vue&type=template&id=4301f99d&scoped=true&"
import script from "./psychologicalCounseling.vue?vue&type=script&lang=js&"
export * from "./psychologicalCounseling.vue?vue&type=script&lang=js&"
import style0 from "./psychologicalCounseling.vue?vue&type=style&index=0&id=4301f99d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4301f99d",
  null
  
)

export default component.exports